<template>
<div class="chapter">
<div class="inner_page">
      ﻿<title>His Love Endures Forever: A Land of Canaan Novel</title>
<link href="default.css" rel="stylesheet" type="text/css"/>
<meta charset="utf-8"/>
<p class="ct" id="p0009-02-0"><a id="pageix"><span><i><img alt="9781595548887_INT_0009_001.jpg" id="p0009-d6e5" src="images/9781595548887_INT_0009_001.jpg"/></i></span></a><i><a href="#/chapter1d#d6e2">  Pennsylvania Dutch Glossary</a></i></p>
<p class="txy2" id="p0009-03-1"><span><i>ab im kopp</i>—crazy or off in the head</span></p>
<p class="txy2" id="p0009-04-2"><span><i>ach</i>—oh</span></p>
<p class="txy2" id="p0009-05-3"><span><i>aentis</i>—aunts</span></p>
<p class="txy2" id="p0009-06-4"><span><i>baremlich</i>—terrible</span></p>
<p class="txy2" id="p0009-07-5"><span><i>boppli</i>—baby</span></p>
<p class="txy2" id="p0009-08-6"><span><i>bruder</i>—brother</span></p>
<p class="txy2" id="p0009-09-7"><span><i>danki</i>—thank you</span></p>
<p class="txy2" id="p0009-10-8"><span><i>daed</i>—dad</span></p>
<p class="txy2" id="p0009-11-9"><span><i>dochder</i>—daughter</span></p>
<p class="txy2" id="p0009-12-10"><span><i>dummkopp</i>—dunce</span></p>
<p class="txy2" id="p0009-13-11"><span><i>dumm</i>—dumb</span></p>
<p class="txy2" id="p0009-14-12"><span><i>Englisch</i>—non-Amish</span></p>
<p class="txy2" id="p0009-15-13"><span><i>Englischers</i>—non-Amish people</span></p>
<p class="txy2" id="p0009-16-14"><span><i>es dutt mir leed—</i>I am sorry</span></p>
<p class="txy2" id="p0009-17-15"><span><i>fraa</i>—wife</span></p>
<p class="txy2" id="p0009-18-16"><span><i>guder mariye</i>—good morning</span></p>
<p class="txy2" id="p0009-19-17"><span><i>gut</i>—good</span></p>
<p class="txy2" id="p0009-20-18"><span><i>hatt</i>—hard</span></p>
<p class="txy2" id="p0009-21-19"><span><i>haus</i>—house</span></p>
<p class="txy2"><span><i>kaffi</i>—coffee</span></p>
<p class="txy2" id="p0010-02-1"><span><i>kapp</i>—prayer covering or cap</span></p>
<p class="txy2" id="p0010-03-2"><span><i>kinner</i>—children or grandchildren</span></p>
<p class="txy2" id="p0010-04-3"><span><i>kumm</i>—come</span></p>
<p class="txy2" id="p0010-05-4"><span><i>lieb</i>—love</span></p>
<p class="txy2" id="p0010-06-5"><span><i>maedel</i>—girl</span></p>
<p class="txy2" id="p0010-07-6"><span><i>mamm</i>—mom</span></p>
<p class="txy2" id="p0010-08-7"><span><i>mammi</i>—grandmother</span></p>
<p class="txy2" id="p0010-09-8"><span><i>mei</i>—my</span></p>
<p class="txy2" id="p0010-10-9"><span><i>mudder</i>—mother</span></p>
<p class="txy2" id="p0010-11-10"><span><i>narrisch</i>—crazy</span></p>
<p class="txy2" id="p0010-12-11"><span><i>nee</i>—no</span></p>
<p class="txy2" id="p0010-13-12"><span><i>onkel</i>—uncle</span></p>
<p class="txy2" id="p0010-14-13"><span><i>Ordnung</i>—the written and unwritten rules of the Amish; the understood behavior by which the Amish are expected to live, passed down from generation to generation. Most Amish know the rules by heart.</span></p>
<p class="txy2" id="p0010-15-15"><span><i>Pennsylvania Deitsch</i>—Pennsylvania German, the language most commonly used by the Amish</span></p>
<p class="txy2" id="p0010-16-16"><span><i>rumschpringe</i>—running-around period when a teenager turns sixteen years old</span></p>
<p class="txy2" id="p0010-17-17"><span><i>schee</i>—pretty</span></p>
<p class="txy2" id="p0010-18-18"><span><i>sohn</i>—son</span></p>
<p class="txy2" id="p0010-19-19"><span><i>wedder</i>—weather</span></p>
<p class="txy2" id="p0010-20-20"><span><i>wie bischt?</i>—how are you?</span></p>
<p class="txy2" id="p0010-21-22"><span><i>ya</i>—yes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?30a9f4f2